var _line, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoratedLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1250,
    height: 41,
    viewBox: "0 0 1250 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 22.8638,
    x2: 1250,
    y2: 22.8637,
    stroke: "#973540"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605 0.36377C605 11.4095 613.954 20.3638 625 20.3638C613.954 20.3638 605 29.3182 605 40.3638H607.4C607.4 30.6436 615.28 22.7638 625 22.7638C634.72 22.7638 642.6 30.6436 642.6 40.3638H645C645 29.3182 636.046 20.3638 625 20.3638C636.046 20.3638 645 11.4095 645 0.36377H642.6C642.6 10.084 634.72 17.9638 625 17.9638C615.28 17.9638 607.4 10.084 607.4 0.36377H605ZM609.8 0.36377C609.8 8.75849 616.605 15.5638 625 15.5638C633.395 15.5638 640.2 8.75849 640.2 0.36377H637.8C637.8 7.43301 632.069 13.1638 625 13.1638C617.931 13.1638 612.2 7.43301 612.2 0.36377H609.8ZM614.6 0.36377C614.6 6.10753 619.256 10.7638 625 10.7638C630.744 10.7638 635.4 6.10753 635.4 0.36377H633C633 4.78205 629.418 8.36377 625 8.36377C620.582 8.36377 617 4.78205 617 0.36377H614.6ZM625 25.1638C633.395 25.1638 640.2 31.969 640.2 40.3638H637.8C637.8 33.2946 632.069 27.5638 625 27.5638C617.931 27.5638 612.2 33.2946 612.2 40.3638H609.8C609.8 31.969 616.605 25.1638 625 25.1638ZM625 29.9638C630.744 29.9638 635.4 34.62 635.4 40.3638H633C633 35.9456 629.418 32.3638 625 32.3638C620.582 32.3638 617 35.9456 617 40.3638H614.6C614.6 34.62 619.256 29.9638 625 29.9638Z",
    fill: "url(#paint0_linear_685_112869)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_685_112869",
    x1: 629.124,
    y1: 40.3638,
    x2: 628.66,
    y2: 0.361978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#962BC7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoratedLine);
export default __webpack_public_path__ + "static/media/decorated_line.4257d4312f0a35260753fec9f0b4847f.svg";
export { ForwardRef as ReactComponent };